// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1dKMT7xjwrfh0vzBVcn54w\\=\\={height:50px;width:4px;background-color:red;position:absolute;right:0px;border-radius:32px;background-color:rgba(3,3,3,.5)}.k1NlGzNOs5nRjscpzFKdIg\\=\\=::-webkit-scrollbar{width:0px;background:rgba(0,0,0,0)}", "",{"version":3,"sources":["webpack://./src/shared/components/ProgrammaticalMobileScroller/ProgrammaticallyMobileScroller.module.scss"],"names":[],"mappings":"AAAA,6BACI,WAAA,CACA,SAAA,CACA,oBAAA,CACA,iBAAA,CACA,SAAA,CACA,kBAAA,CACA,+BAAA,CAMA,+CACE,SAAA,CACA,wBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollStick": "_1dKMT7xjwrfh0vzBVcn54w==",
	"scrollParent": "k1NlGzNOs5nRjscpzFKdIg=="
};
export default ___CSS_LOADER_EXPORT___;
